import {
  Animated,
  NativeScrollEvent,
  NativeSyntheticEvent,
} from 'react-native';
import { useCallback, useMemo, useRef } from 'react';
import {
  usePageLayoutBodyScroll,
  usePageLayoutHeaderInset,
} from '@usepepper/sprout-kit-ui';

type ScrollEvent = NativeSyntheticEvent<NativeScrollEvent>;

export const useQuickReturnHeaderScroll = () => {
  const { onScroll } = usePageLayoutBodyScroll();
  const headerInset = usePageLayoutHeaderInset();
  const lastOffset = useRef(0);
  const hiddenBy = useRef(0);
  const headerHiddenBy = useMemo(() => new Animated.Value(0), []);

  const handleScroll = useCallback(
    (event: ScrollEvent) => {
      if (headerInset === 0) {
        onScroll(event);
        return;
      }
      const { contentOffset, contentSize, layoutMeasurement } =
        event.nativeEvent;
      const maxOffset = Math.max(
        0,
        contentSize.height - layoutMeasurement.height,
      );
      const offset = Math.min(maxOffset, Math.max(0, contentOffset.y));
      const next = hiddenBy.current + offset - lastOffset.current;
      hiddenBy.current = Math.min(
        offset,
        Math.max(0, Math.min(headerInset, next)),
      );
      lastOffset.current = offset;
      headerHiddenBy.setValue(hiddenBy.current);
      onScroll({
        ...event,
        nativeEvent: {
          ...event.nativeEvent,
          contentOffset: {
            ...event.nativeEvent.contentOffset,
            y: hiddenBy.current,
          },
        },
      });
    },
    [headerHiddenBy, headerInset, onScroll],
  );

  return { handleScroll, headerHiddenBy, headerInset };
};
